export default {
  namespaced: true,
  state: {
    messages: [],
    defaultDelay: 5000,
  },
  mutations: {
    notify(state, message) {
      message.target = message.target || 'main';

      const similar = state.messages.some((item) => item.type === message.type && item.text === message.text);

      if (!similar) {
        state.messages.unshift(message);
      }
    },
    deleteMessage(state, message) {
      const index = state.messages.indexOf(message);

      if (index !== -1) {
        state.messages.splice(index, 1);
      }
    },
    clearMessages(state, target) {
      state.messages = state.messages.filter((message) => message.target !== target);
    },
  },
  actions: {
    showMessage({ commit }, message) {
      commit('notify', message);
    },
    async clearMessages({ commit }, target) {
      await commit('clearMessages', target);
    },
    notify({ commit, state }, message) {
      const object = { ...message };
      object.timerId = setTimeout(() => {
        commit('deleteMessage', object);
      }, object.delay || state.defaultDelay);

      commit('notify', object);
    },
    deleteMessage({ commit }, message) {
      commit('deleteMessage', message);
      clearTimeout(message.timerId);
    },
  },
};
